import React from 'react';
import { Icon } from '@chakra-ui/react';

const TikTokIcon = (props) => (
  <Icon viewBox="0 0 32 32" fill="currentColor" {...props}>
    <svg
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 800 800">
      <path
        className="st0"
        d="M644,185.4c-5.1-2.6-10-5.5-14.8-8.6-13.9-9.2-26.6-20-37.9-32.2-28.3-32.4-38.8-65.2-42.7-88.2h.2c-3.2-19.1-1.9-31.4-1.7-31.4h-128.8v498.1c0,6.7,0,13.3-.3,19.8,0,.8,0,1.6-.1,2.4,0,.4,0,.7,0,1.1v.3c-2.8,36.3-23.4,68.8-55,86.8-16.2,9.2-34.6,14.1-53.3,14.1-60,0-108.7-48.9-108.7-109.4s48.6-109.4,108.7-109.4c11.4,0,22.7,1.8,33.5,5.3l.2-131.2c-66.3-8.6-133.1,11-184.4,53.9-22.2,19.3-40.9,42.3-55.2,68-5.4,9.4-26,47-28.4,108.2-1.6,34.7,8.9,70.7,13.8,85.5v.3c3.1,8.8,15.2,38.6,35,63.8,15.9,20.2,34.7,37.9,55.8,52.6v-.3l.3.3c62.4,42.4,131.5,39.6,131.5,39.6,12-.5,52.1,0,97.6-21.6,50.5-23.9,79.3-59.6,79.3-59.6,18.4-21.3,33-45.6,43.2-71.8,11.7-30.6,15.5-67.4,15.5-82.1v-264.3c1.6.9,22.4,14.7,22.4,14.7,0,0,30,19.2,76.8,31.7,33.6,8.9,78.8,10.8,78.8,10.8v-127.9c-15.8,1.7-48-3.3-81-19.7Z"
      />
    </svg>
  </Icon>
);

export default TikTokIcon;
